import { render } from "./YoutubeSection.vue?vue&type=template&id=18a19dd2"
import script from "./YoutubeSection.vue?vue&type=script&lang=js"
export * from "./YoutubeSection.vue?vue&type=script&lang=js"

import "./YoutubeSection.vue?vue&type=style&index=0&id=18a19dd2&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__